import { ActivityType } from "../activity/activity.class";

export interface ShortCallContent {
  title: string;
  showSkeleton: boolean;
  cards: ContentCard[];
}

export interface ContentCard {
  contentId: string;
  imageUrl: string;
  name: string;
  tags: ChildTag[];
  selected?: boolean;
}

export interface PresentationUserTag {
  indskr_usertagid: string;
  indskr_name: string;
  presentation_id: string;
  parent_tag_name: string;
  parent_tag_id: string;
}

export interface PresentationTagGroup {
  presentation_id: string;
  tags: ChildTag[];
}

export interface ChildTag {
  indskr_name: string;
  indskr_usertagid: string;
}

export interface ParentTag {
  childTags: ChildTag[];
  parent_tag_id: string;
  parent_tag_name: string;
}

export interface UserTagData {
  presentationTags: PresentationTagGroup[];
  parentTags: ParentTag[];
}

export interface ShortCallField {
  label: string;
  value: string;
  selected?: boolean;
}

export interface ShortCallFilterField extends ShortCallField {
  tags: ShortCallField[];
}

export interface ActivityFeedback {
  label: string;
  icon: string;
  value: number;
}

export interface TodoItem {
  id: string,
  type: ActivityType;
  start_date: number;
  modifiedon: number;
  indskr_suggestionrescheduled?: boolean;
  field_to_sort?: string;
  rows: any[]
}

export interface TodoMasterData {
  date: string;
  first_sync_for_today: boolean;
  todos: TodoItem[];
}